import { BRAND, MARK } from "../lib/brand";

export const Mark = () => {
  return (
    <section id="mark" data-testid="mark-section" className="relative py-24 lg:py-32 bg-navy overflow-hidden grain">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div className="max-w-xl">
            <p className="uppercase tracking-[0.2em] text-xs font-semibold text-gold mb-4">The meaning behind the mark</p>
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight">
              How a prism becomes a <span className="gold-text">method</span>
            </h2>
          </div>
          <img src={BRAND.prism} alt="Six12 prism mark" className="floaty w-40 h-40 object-contain" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-px bg-white/10 border border-white/10">
          {MARK.map((m, i) => (
            <div
              key={m.label}
              data-testid={`mark-${i}`}
              className="bg-navy p-8 hover:bg-navy-800 transition-colors group"
            >
              <div className="text-xs font-display gold-text mb-4">0{i + 1}</div>
              <h3 className="font-display text-xl mb-3 group-hover:text-gold transition-colors">{m.label}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{m.text}</p>
            </div>
          ))}
        </div>

        <p className="mt-12 text-center text-sm uppercase tracking-[0.3em] text-slate-500">
          Strategy &nbsp;·&nbsp; Protection &nbsp;·&nbsp; Partnership &nbsp;·&nbsp; Preparation
        </p>
      </div>
    </section>
  );
};
